module.exports = __webpack_public_path__ + "img/duanwu_ps_06.9c71ed4c.jpg";